__webpack_require__.p = "https://metrics.bitazza.com/";